<div
  class="k-dropdown"
  [ngClass]="{ expanded: isOpen, 'icon-only': iconOnly }"
  (baseClickOutside)="isOpen = false"
>
  <button
    type="button"
    [class]="'text-nowrap btn btn-md btn-' + color"
    [ngClass]="{ 'small-padding': smallPadding }"
    [disabled]="disabled"
    (click)="toggle()"
  >
    <span
      *ngIf="!iconOnly"
      baseTruncate
      >{{ label | translate }}</span
    >
    <i
      class="fa-solid fa-fw"
      [ngClass]="isOpen ? 'fa-angle-up' : 'fa-angle-down'"
    ></i>
  </button>
  <div
    class="menu"
    [ngClass]="{ open: isOpen, upward: shouldOpenUpward && isOpen }"
    (click)="isOpen = false"
    #dropdownElement
  >
    <ul [ngClass]="{ 'list-unstyled': true, 'd-block': label === 'action.export' }">
      <ng-container *ngFor="let item of items; let i = index">
        <li
          class="pointer"
          [ngClass]="{ 'd-flex align-items-center justify-content-start': label === 'action.export' }"
          (click)="onClickListItem(item)"
        >
          <i
            *ngIf="label === 'action.export'"
            class="fa-solid fa-file-export ms-0 me-2"
          ></i>
          <span>{{ item | translate }}</span>
        </li>
        <hr *ngIf="i !== items.length - 1" />
      </ng-container>
    </ul>
  </div>
</div>
